// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/" + chunkId + "." + chunkId + "." + {"1119":"a3751956","2148":"8170a39e","2589":"d58c8f4e"}[chunkId] + ".css";
};